import React from "react";
import {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  ListOrdered,
  List,
  IndentDecrease,
  IndentIncrease,
} from "lucide-react";

const ICON_SIZE = 12;

const ToolbarButton = ({ onClick, isActive, title, children }) => (
  <button
    type="button"
    className={`editor-toolbar-btn${isActive ? " is-active" : ""}`}
    onClick={onClick}
    title={title}
  >
    {children}
  </button>
);

const EditorToolbar = ({ editor, toolbarType = "full" }) => {
  if (!editor) return null;

  return (
    <div className="editor-toolbar">
      <div className="editor-toolbar-group">
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBold().run()}
          isActive={editor.isActive("bold")}
          title="Bold"
        >
          <Bold size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleItalic().run()}
          isActive={editor.isActive("italic")}
          title="Italic"
        >
          <Italic size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          isActive={editor.isActive("underline")}
          title="Underline"
        >
          <Underline size={ICON_SIZE} />
        </ToolbarButton>
        {toolbarType === "minimal" && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleStrike().run()}
            isActive={editor.isActive("strike")}
            title="Strikethrough"
          >
            <Strikethrough size={ICON_SIZE} />
          </ToolbarButton>
        )}
      </div>

      <div className="editor-toolbar-group">
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          isActive={editor.isActive("orderedList")}
          title="Ordered List"
        >
          <ListOrdered size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          isActive={editor.isActive("bulletList")}
          title="Bullet List"
        >
          <List size={ICON_SIZE} />
        </ToolbarButton>
      </div>

      {toolbarType === "full" && (
        <div className="editor-toolbar-group">
          <ToolbarButton
            onClick={() => editor.chain().focus().liftListItem("listItem").run()}
            isActive={false}
            title="Decrease Indent"
          >
            <IndentDecrease size={ICON_SIZE} />
          </ToolbarButton>
          <ToolbarButton
            onClick={() => editor.chain().focus().sinkListItem("listItem").run()}
            isActive={false}
            title="Increase Indent"
          >
            <IndentIncrease size={ICON_SIZE} />
          </ToolbarButton>
        </div>
      )}
    </div>
  );
};

export default EditorToolbar;
